/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *
 * @file BookAndPageLevelTab.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import BookAndPageTabsStyle from './BookAndPageTabsStyle';
import BookAndPageTabStyle from './BookAndPageTabStyle';
import ResourceUtils from '../../utils/ResourceUtils';
import messages from '../../../translations/defaultMessages';

const a11yProps = (index) => ({
  id: `book-page-tab-${index}`,
  'aria-controls': `book-page-tabpanel-${index}`
});

const BookAndPageLevelTab = ({
  bulkDownloadStatus,
  handleTabChange,
  hasBookResource,
  hasPageResource,
  intl,
  tabValue
}) => {
  const { formatMessage } = intl;

  /**
   * Handle book and page level tab change
   * @param {} event
   * @param {*} currentValue
   */
  const handleChange = (event, currentValue) => {
    handleTabChange(currentValue);
  };
  const isBulkDownloadInProgress = ResourceUtils.isBulkDownloadInProgress(bulkDownloadStatus);

  return (
    <div>
      <BookAndPageTabsStyle
        aria-label="User Role"
        indicatorColor="primary"
        onChange={hasBookResource && hasPageResource && handleChange}
        textColor="primary"
        value={hasBookResource && hasPageResource ? tabValue : 0}
        variant="fullWidth"
      >
        {hasBookResource && <BookAndPageTabStyle
          disabled={isBulkDownloadInProgress}
          label={formatMessage(messages.book)}
          {...a11yProps(0)}
        />}
        {hasPageResource && <BookAndPageTabStyle
          disabled={isBulkDownloadInProgress}
          label={formatMessage(messages.page)}
          {...a11yProps(1)}
        />}
      </BookAndPageTabsStyle>
    </div>
  );
};

BookAndPageLevelTab.propTypes = {
  bulkDownloadStatus: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  hasBookResource: PropTypes.bool.isRequired,
  hasPageResource: PropTypes.bool.isRequired,
  intl: intlShape,
  tabValue: PropTypes.number.isRequired
};

BookAndPageLevelTab.defaultProps = {
  intl: {}
};

export default injectIntl(BookAndPageLevelTab);
